import { canExpandGroup } from "./canExpandGroup"
import { getColumnId } from "./getColumnId"
import { DataColumn, GroupColumn } from "./types"

export function getVisibleColumns<T>(
  group: GroupColumn<T>,
  expandedGroupTitles: Set<string>,
  hiddenColumns?: Set<string>
): DataColumn<T>[] {
  if (!canExpandGroup(group) || expandedGroupTitles.has(group.title)) {
    return group.columns.filter(
      (col) => !hiddenColumns?.has(getColumnId(col, group))
    )
  }

  if (group.minVisibleColumns === 0) return []

  const visible: DataColumn<T>[] = []
  for (const col of group.columns) {
    if (hiddenColumns?.has(getColumnId(col, group))) continue

    visible.push(col)
    if (visible.length === group.minVisibleColumns) break
  }
  return visible
}
